module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "configuration-view-wrapper"
  }, [_c('h1', [_vm._v("Alterar Senha")]), _c('fieldset', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.apiErrorMessages), function(message) {
    return _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(message))])
  }), 0), _c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.has('current_password')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "current-password"
    }
  }, [_vm._v("Senha atual")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.current_password),
      expression: "credentials.current_password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "current-password",
      "name": "current_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "current_password", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('current_password')),
      expression: "errors.has('current_password')"
    }],
    key: "current_password",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('current_password')))])])], 1), _c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Nova senha")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "new-password",
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    key: "password",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])], 1), _c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password-confirmation"
    }
  }, [_vm._v("Confirmar nova senha")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('confirmed:password'),
      expression: "'confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password_confirmation),
      expression: "credentials.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "new-password-confirmation",
      "name": "password_confirmation",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password_confirmation", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password_confirmation')),
      expression: "errors.has('password_confirmation')"
    }],
    key: "password_confirmation",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])])], 1), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("Salvar")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2d3be56!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/change_password.vue
// module id = 1193
// module chunks = 1